import {useQuery_deprecated as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

import useScript from './useScript'

export default function useAppleMaps() {
  const {mapKitToken} = useQuery(gql`
    query getMapKitToken {
      mapKitToken
    }
  `)

  useScript('https://cdn.apple-mapkit.com/mk/5.x.x/mapkit.js', () => {
    global.mapkit.init({authorizationCallback: done => done(mapKitToken)})
  })

  return global.mapkit
}
